<ui-loading-spinner
  *ngIf="(loading$ | async) && (pricingFeeDiscountData$ | async) === null"
  class="py-9"></ui-loading-spinner>
<ng-container *ngIf="pricingFeeDiscountData$ | async as feeDiscountData">
  <div data-element="fees-taxes-discounts-container" class="@container fees-taxes-discounts-container">
    <!-- Security deposit -->
    <mat-divider *ngIf="!section" class="!my-6"></mat-divider>
    <div *ngIf="!section || section === 'security-deposit'">
      <div class="flex items-center justify-between gap-3 mb-1">
        <h3 #section class="flex-1" id="security-deposit">
          <div class="flex items-center gap-4">
            <span>Security deposit</span>
          </div>
        </h3>
        <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.securityDeposits"></sbnb-save-indicator>
      </div>

      <span class="text-sm text-night block mb-6">
        Choose how you want to handle deposits, collect them yourself or let Hospitable do it for you.
      </span>

      <div *ngIf="displayAutomaticSecurityDeposit$ | async" class="mb-6">
        <div class="mb-6">
          <h4 class="mb-2 text-grape-darker">Automatic</h4>
          <span class="text-sm text-night">
            Hospitable collects and refunds the deposit for you. Applies to new reservations only.&nbsp;
            <a
              class="link"
              href="https://help.hospitable.com/en/collections/12954619-security-deposits"
              target="_blank">
              Learn more
            </a>
          </span>
        </div>

        <div
          *ngIf="featureFlagAirbnbSecurityDepositsEnabled$ | async"
          class="ml-4 flex @md:items-center @md:gap-3 gap-1 mb-4 @md:flex-row flex-col">
          <span class="flex-1 text-sm flex flex-col gap-1">
            <span class="flex items-center justify-between">
              <span class="strong flex-1">Airbnb deposit</span>
              <ui-icon-airbnb [size]="12" class="@md:hidden mr-[2px]"></ui-icon-airbnb>
            </span>
            <span class="text-sm text-night">
              Collected 2 days before check-in, released 2 days after. Guest notified automatically.
              <br />
              ID screening & chargeback protection included. 2% fee applies.
            </span>
          </span>

          <ui-icon-airbnb [size]="12" class="hidden @md:block"></ui-icon-airbnb>

          <mat-form-field
            class="nopadding w-full @md:w-[240px] [&_.mat-form-field-flex]:!pr-0 [&_.mat-form-field-suffix]:flex [&_.mat-form-field-suffix]:self-stretch [&_.mat-form-field-suffix]:mb-1"
            [matTooltip]="(securityDepositRestrictionReason$ | async) || ''">
            <input
              matInput
              type="tel"
              inputmode="numeric"
              maxlength="6"
              autocomplete="off"
              placeholder="0"
              [disabled]="(allowAutomaticSecurityDeposits$ | async) === false"
              [(ngModel)]="feeDiscountData['airbnb_security_deposit'].value"
              (change)="savePriceChange('airbnb_security_deposit', feeDiscountData['airbnb_security_deposit'])" />
            <span matSuffix class="h-full flex items-center rounded-r-md text-xs bg-gray-100 px-3">{{
              property.currency | currencyCode
            }}</span>
          </mat-form-field>
        </div>

        <div class="ml-4 flex @md:items-center @md:gap-3 gap-1 mb-4 @md:flex-row flex-col">
          <span class="flex-1 text-sm flex flex-col gap-1">
            <span class="flex items-center justify-between">
              <span class="strong flex1">Direct deposit</span>
              <sbnb-property-update-status
                *ngIf="isPremium$ | async"
                class="@md:hidden mr-[2px]"
                [edited]="feeDiscountData['direct_security_deposit_v2'].edited"
                [hasAirbnbListing]="false"></sbnb-property-update-status>
            </span>
            <span class="text-sm">
              Collected 2 days before check-in, released 2 days after. Guest notified automatically.
              <br />
              Chargeback protection included. 2% fee applies.
            </span>
          </span>

          <sbnb-property-update-status
            *ngIf="isPremium$ | async"
            class="hidden @md:block"
            [edited]="feeDiscountData['direct_security_deposit_v2'].edited"
            [hasAirbnbListing]="false"></sbnb-property-update-status>

          <mat-form-field
            *ngIf="isPremium$ | async"
            class="nopadding w-full @md:w-[240px] [&_.mat-form-field-flex]:!pr-0 [&_.mat-form-field-suffix]:flex [&_.mat-form-field-suffix]:self-stretch [&_.mat-form-field-suffix]:mb-1"
            [matTooltip]="(securityDepositRestrictionReason$ | async) || ''">
            <input
              matInput
              type="tel"
              inputmode="numeric"
              maxlength="6"
              autocomplete="off"
              placeholder="0"
              [disabled]="(allowAutomaticSecurityDeposits$ | async) === false"
              [(ngModel)]="feeDiscountData['direct_security_deposit_v2'].value"
              (change)="savePriceChange('direct_security_deposit_v2', feeDiscountData['direct_security_deposit_v2'])" />
            <span matSuffix class="h-full flex items-center rounded-r-md text-xs bg-gray-100 px-3">{{
              property.currency | currencyCode
            }}</span>
          </mat-form-field>
        </div>

        <div
          *ngIf="featureFlagBookingComSecurityDepositsEnabled$ | async"
          class="ml-4 flex @md:items-center @md:gap-3 gap-1 @md:flex-row flex-col">
          <span class="flex-1 text-sm flex flex-col gap-1">
            <span class="flex items-center justify-between">
              <span class="strong flex-1">Booking.com deposit</span>
              <ui-icon-booking [size]="12" class="@md:hidden mr-[2px]"></ui-icon-booking>
            </span>
            <span class="text-sm text-night">
              Collected 2 days before check-in, released 2 days after. Guest notified automatically.
              <br />
              Chargeback protection included. 2% fee applies.
            </span>
          </span>

          <ui-icon-booking [size]="12" class="hidden @md:block"></ui-icon-booking>

          <mat-form-field
            class="nopadding w-full @md:w-[240px] [&_.mat-form-field-flex]:!pr-0 [&_.mat-form-field-suffix]:flex [&_.mat-form-field-suffix]:self-stretch [&_.mat-form-field-suffix]:mb-1"
            [matTooltip]="(securityDepositRestrictionReason$ | async) || ''">
            <input
              matInput
              inputmode="numeric"
              maxlength="6"
              autocomplete="off"
              placeholder="0"
              [disabled]="(allowAutomaticSecurityDeposits$ | async) === false"
              [(ngModel)]="feeDiscountData['booking_com_security_deposit'].value"
              (change)="
                savePriceChange('booking_com_security_deposit', feeDiscountData['booking_com_security_deposit'])
              " />
            <span matSuffix class="h-full flex items-center rounded-r-md text-xs bg-gray-100 px-3">{{
              property.currency | currencyCode
            }}</span>
          </mat-form-field>
        </div>

        <!-- Payout Method Section for Security Deposits -->
        <div *ngIf="featureFlagAirbnbSecurityDepositsEnabled$ | async" class="ml-4 mt-6">
          <div class="flex @md:items-center @md:gap-3 gap-1 mb-4 @md:flex-row flex-col">
            <span class="flex-1 text-sm flex flex-col gap-1">
              <span class="flex items-center justify-between">
                <span class="strong flex-1">Deposit payout method</span>
              </span>
              <span class="text-sm text-night">
                Choose which payout method should receive payments for security deposits on this property.
              </span>
            </span>
          </div>

          <div>
            <!-- Show payout method card if one is assigned -->
            <div *ngIf="property.security_deposit_payout_method" class="max-w-sm">
              <sbnb-payout-method-card
                [accountName]="
                  property.security_deposit_payout_method.name ?? property.security_deposit_payout_method.derived_name
                "
                [status]="getPayoutMethodStatus(property.security_deposit_payout_method)"
                [isDefault]="
                  property.security_deposit_payout_method.is_default ||
                  property.security_deposit_payout_method.all_properties
                "
                [verificationErrors]="property.security_deposit_payout_method.adyen?.verification_errors"
                [actions]="getPayoutMethodActions(property.security_deposit_payout_method)"
                [accountHolderId]="property.security_deposit_payout_method.adyen?.account_holder_id"
                [lastFour]="
                  property.security_deposit_payout_method.adyen?.bank_account_number
                    ? property.security_deposit_payout_method.adyen.bank_account_number.slice(-4)
                    : null
                "
                [bankName]="
                  property.security_deposit_payout_method.balance_account?.account_holder?.legal_entity
                    ?.transfer_instruments[0]?.metadata?.bankAccount?.bankName
                "
                (actionClicked)="onPayoutMethodActionClicked(property.security_deposit_payout_method, $event)">
              </sbnb-payout-method-card>
            </div>

            <!-- Empty state when no payout method is assigned -->
            <div
              *ngIf="!property.security_deposit_payout_method"
              class="border border-dashed border-smoke rounded-2xl p-8 text-center max-w-sm">
              <div class="flex flex-col items-center gap-4">
                <div class="flex flex-col gap-2">
                  <h4 class="text-night-darker font-medium mb-0">Based on property</h4>
                  <p class="text-sm text-night-lighter mb-0"
                    >This property will use the payout method assigned to it for security deposit payments.</p
                  >
                </div>
                <sbnb-button
                  size="mini"
                  type="secondary"
                  label="Assign custom payout method"
                  (clicked)="onPayoutMethodActionClicked(null, 'edit')"></sbnb-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-6">
        <div class="mb-6">
          <h4 class="mb-2 text-grape-darker">Manual</h4>
          <span class="text-sm text-night">You collect the deposit offline.</span>
        </div>

        <div class="ml-4 flex @md:items-center @md:gap-3 gap-1 mb-4 @md:flex-row flex-col">
          <span class="flex-1 text-sm flex flex-col gap-1">
            <span class="flex items-center justify-between">
              <span class="strong flex-1">Airbnb deposit</span>
              <ui-icon-airbnb [size]="12" class="@md:hidden mr-[2px]"></ui-icon-airbnb>
            </span>
            <span class="text-sm text-night">
              Shown at checkout. You collect it manually. &nbsp;
              <a
                class="link"
                href="https://help.hospitable.com/en/articles/6262321-security-deposits-for-airbnb"
                target="_blank">
                Learn more
              </a>
            </span>
          </span>

          <ui-icon-airbnb [size]="12" class="hidden @md:block"></ui-icon-airbnb>

          <mat-form-field
            class="nopadding w-full @md:w-[240px] [&_.mat-form-field-flex]:!pr-0 [&_.mat-form-field-suffix]:flex [&_.mat-form-field-suffix]:self-stretch [&_.mat-form-field-suffix]:mb-1">
            <input
              matInput
              type="tel"
              inputmode="numeric"
              maxlength="6"
              autocomplete="off"
              placeholder="0"
              [(ngModel)]="feeDiscountData['security_deposit'].value"
              (change)="savePriceChange('security_deposit', feeDiscountData['security_deposit'])" />
            <span matSuffix class="h-full flex items-center rounded-r-md text-xs bg-gray-100 px-3">{{
              property.currency | currencyCode
            }}</span>
          </mat-form-field>
        </div>

        <div class="ml-4 flex @md:items-center @md:gap-3 gap-1 @md:flex-row flex-col">
          <span class="flex-1 text-sm flex flex-col gap-1">
            <span class="flex items-center justify-between">
              <span class="strong flex-1">Direct deposit</span>
              <sbnb-property-update-status
                class="@md:hidden mr-[2px]"
                [edited]="feeDiscountData['direct_security_deposit'].edited"
                [hasAirbnbListing]="false"></sbnb-property-update-status>
            </span>
            <span class="text-sm text-night">Sent to guests using a shortcode. You collect it manually.</span>
          </span>

          <sbnb-property-update-status
            class="hidden @md:block"
            [edited]="feeDiscountData['direct_security_deposit'].edited"
            [hasAirbnbListing]="false"></sbnb-property-update-status>

          <mat-form-field
            class="nopadding w-full @md:w-[240px] [&_.mat-form-field-flex]:!pr-0 [&_.mat-form-field-suffix]:flex [&_.mat-form-field-suffix]:self-stretch [&_.mat-form-field-suffix]:mb-1">
            <input
              matInput
              type="tel"
              inputmode="numeric"
              maxlength="6"
              autocomplete="off"
              placeholder="0"
              [(ngModel)]="feeDiscountData['direct_security_deposit'].value"
              (change)="savePriceChange('direct_security_deposit', feeDiscountData['direct_security_deposit'])" />
            <span matSuffix class="h-full flex items-center rounded-r-md text-xs bg-gray-100 px-3">{{
              property.currency | currencyCode
            }}</span>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Occupancy based -->
    <mat-divider *ngIf="!section" class="!my-6"></mat-divider>
    <div *ngIf="!section || section === 'occupancy-based'">
      <div class="flex items-center justify-between gap-3 mb-4">
        <div class="flex flex-col gap-1">
          <h3 #section class="flex-1" id="fees">Occupancy based</h3>
          <ng-template [ngTemplateOutlet]="iconLegend"></ng-template>
        </div>
        <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.occupancyBased"></sbnb-save-indicator>
      </div>

      <div
        *ngFor="let occupancy of occupancyBased"
        class="flex @md:items-center @md:gap-3 gap-1 mb-4 @md:mb-2 @md:flex-row flex-col">
        <span class="flex-1 text-sm flex flex-col gap-1">
          <span class="flex items-center justify-between">
            <span class="strong flex-1">{{ occupancy.label }}</span>
            <sbnb-property-update-status
              [hasAirbnbListing]="property.counts?.airbnb > 0"
              [hasBookingListing]="
                occupancy.key === 'person_capacity' ? property.counts?.booking_managed > 0 : property.counts.booking > 0
              "
              class="@md:hidden mr-[2px]"></sbnb-property-update-status>
          </span>
          <span *ngIf="occupancy.description" class="text-sm text-night">
            {{ occupancy.description }}
          </span>
        </span>
        <div class="flex flex-col gap-2 @md:items-end">
          <div class="flex gap-3 items-center">
            <sbnb-property-update-status
              [hasAirbnbListing]="property.counts?.airbnb > 0"
              [hasBookingListing]="
                occupancy.key === 'person_capacity' ? property.counts?.booking_managed > 0 : property.counts.booking > 0
              "
              class="hidden @md:block"></sbnb-property-update-status>

            <mat-form-field class="input__mini w-full nopadding @md:!max-w-[120px]">
              <span *ngIf="occupancy.key === 'price_per_extra_person'" matPrefix class="prefix-bg">
                <span class="text__small" style="padding-right: 12px">{{ property.currency | currencyCode }}</span>
              </span>
              @if (occupancy.key === 'guests_included' && +feeDiscountData['price_per_extra_person'].value === 0) {
                <input
                  matInput
                  maxlength="6"
                  autocomplete="off"
                  placeholder="0"
                  [value]="feeDiscountData['person_capacity'].value"
                  disabled />
              } @else {
                <input
                  matInput
                  type="tel"
                  placeholder="0"
                  [(ngModel)]="feeDiscountData[occupancy.key].value"
                  (change)="savePriceChange(occupancy.key, feeDiscountData[occupancy.key])"
                  [disabled]="occupancy.key === 'person_capacity'"
                  [matTooltip]="occupancy.key === 'person_capacity' ? 'Update in property details' : ''" />
              }
              <span matSuffix *ngIf="occupancy.key !== 'price_per_extra_person'">guests</span>
            </mat-form-field>
          </div>
          <a
            *ngIf="occupancy.key === 'person_capacity'"
            class="link-grape text-xs"
            [routerLink]="['/properties/property/', property.id, 'details']">
            Edit in property details
          </a>
        </div>
      </div>
    </div>

    <!-- Fees -->
    <mat-divider *ngIf="!section" class="!my-6"></mat-divider>
    <ng-container *ngIf="!section || section === 'fees'">
      <div>
        <div class="flex items-center justify-between gap-3 pr-4 mb-4">
          <div class="flex flex-col gap-1">
            <h3 #section class="flex-1" id="fees">Fees</h3>
            <ng-template [ngTemplateOutlet]="iconLegend"></ng-template>
          </div>
          <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.fees"></sbnb-save-indicator>
        </div>

        <div class="mb-4 text-sm text-night">
          These fees are managed by Hospitable.com. Learn more about fee management in
          <a
            href="https://help.hospitable.com/en/articles/6141381-property-details-pricing"
            target="_blank"
            class="link-grape">
            our help center
          </a>
        </div>

        <div
          *ngFor="let fee of fees"
          class="flex @md:items-center @md:gap-3 gap-1 mb-4 @md:mb-2 @md:flex-row flex-col @md:h-11">
          <span class="flex-1 text-sm flex flex-col gap-1">
            <span class="flex items-center justify-between">
              <span class="strong flex-1">{{ fee.label }}</span>
              <sbnb-property-update-status
                [edited]="feeDiscountData[fee.key].edited"
                [hasAirbnbListing]="property.counts?.airbnb > 0"
                [hasBookingListing]="fee.key === 'pet_fee' ? false : property.counts?.booking_managed > 0"
                class="@md:hidden mr-[2px]"></sbnb-property-update-status>
            </span>
            <span *ngIf="fee.description" class="text-sm text-night">
              {{ fee.descriptionFeatureFlag ?? fee.description }}
            </span>
          </span>

          <sbnb-property-update-status
            [edited]="feeDiscountData[fee.key].edited"
            [hasAirbnbListing]="property.counts?.airbnb > 0"
            [hasBookingListing]="fee.key === 'pet_fee' ? false : property.counts?.booking_managed > 0"
            class="hidden @md:block"></sbnb-property-update-status>

          <div class="flex gap-3">
            <mat-form-field class="input__mini nopadding flex-auto max-w-[160px]" *ngIf="fee.calculationTypes">
              <mat-select
                [disabled]="fee.calculationTypes.length === 1"
                [(ngModel)]="feeDiscountData[fee.key].calculation_type"
                (selectionChange)="savePriceChange(fee.key, feeDiscountData[fee.key])">
                <mat-option
                  *ngFor="let calculationType of fee.calculationTypes"
                  [value]="calculationType.value"
                  [disabled]="!calculationType[feeDiscountData[fee.key].type]">
                  {{ calculationType.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="input__mini nopadding @md:max-w-[120px]">
              <input
                matInput
                type="tel"
                inputmode="numeric"
                maxlength="6"
                autocomplete="off"
                placeholder="0"
                [(ngModel)]="feeDiscountData[fee.key].value"
                (change)="savePriceChange(fee.key, feeDiscountData[fee.key])" />
              <span
                *ngIf="fee.fixed || fee.percentage"
                matSuffix
                class="text-xs suffix-bg"
                [class.pointer-events]="fee.fixed === false || fee.percentage === false"
                [matMenuTriggerFor]="typeMenu">
                {{ feeDiscountData[fee.key].type === 'fixed' ? property.currency : '%' }}
                <img
                  *ngIf="fee.fixed && fee.percentage"
                  class="clickable"
                  style="width: 12px; margin-left: 4px"
                  src="/assets/images/down-arrow.svg" />
              </span>
            </mat-form-field>

            <mat-menu #typeMenu="matMenu">
              <button
                mat-menu-item
                (click)="
                  feeDiscountData[fee.key].type = 'fixed';
                  invlidateIncompatibleCalculationType(fee.key, feeDiscountData[fee.key], 'fixed');
                  savePriceChange(fee.key, feeDiscountData[fee.key])
                ">
                {{ property.currency }}
              </button>
              <button
                mat-menu-item
                (click)="
                  feeDiscountData[fee.key].type = 'percent';
                  invlidateIncompatibleCalculationType(fee.key, feeDiscountData[fee.key], 'percent');
                  savePriceChange(fee.key, feeDiscountData[fee.key])
                ">
                %
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Discounts -->
    <mat-divider *ngIf="!section" class="!my-6"></mat-divider>
    <div *ngIf="!section || section === 'discounts'">
      <div class="flex items-center justify-between gap-3 mb-4">
        <div class="flex flex-col gap-1">
          <h3 #section class="flex-1" id="discounts">Discounts</h3>
          <ng-template [ngTemplateOutlet]="iconLegend"></ng-template>
        </div>
        <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.discounts"></sbnb-save-indicator>
      </div>
      <ng-container *ngFor="let discount of discounts">
        <ng-container [ngSwitch]="discount.key">
          <ng-container *ngSwitchDefault>
            <div class="flex @md:items-center @md:gap-3 gap-1 mb-4 @md:mb-2 @md:flex-row flex-col">
              <span class="flex-1 text-sm flex flex-col gap-1">
                <span class="flex items-center justify-between">
                  <span class="strong flex-1">{{ discount.label }}</span>
                  <sbnb-property-update-status
                    [edited]="feeDiscountData[discount.key].edited"
                    [hasAirbnbListing]="property.counts?.airbnb > 0"
                    class="@md:hidden mr-[2px]"></sbnb-property-update-status>
                </span>
                <span *ngIf="discount.description" class="text-sm text-night">
                  {{ discount.description }}
                </span>
              </span>
              <sbnb-property-update-status
                [edited]="feeDiscountData[discount.key].edited"
                [hasAirbnbListing]="property.counts?.airbnb > 0"
                class="hidden @md:block"></sbnb-property-update-status>
              <mat-form-field
                class="nopadding w-full @md:w-[240px] [&_.mat-form-field-flex]:!pr-0 [&_.mat-form-field-suffix]:flex [&_.mat-form-field-suffix]:!top-0 [&_.mat-form-field-suffix]:items-center [&_.mat-form-field-suffix]:self-stretch [&_.mat-form-field-suffix]:mb-1">
                <input
                  matInput
                  type="tel"
                  inputmode="numeric"
                  maxlength="6"
                  autocomplete="off"
                  placeholder="0"
                  [(ngModel)]="feeDiscountData[discount.key].value"
                  (change)="savePriceChange(discount.key, feeDiscountData[discount.key])" />
                <span matSuffix class="h-full flex items-center rounded-r-md text-xs bg-gray-100 px-3 mt-2">%</span>
              </mat-form-field>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'early_bird_discount'">
            <div
              *ngIf="featureFlagAirbnbDiscountsEnabled$ | async"
              class="flex @md:gap-3 gap-1 mb-4 @md:mb-2 @md:flex-row flex-col">
              <span class="flex-1 text-sm flex flex-col gap-1">
                <span class="flex items-center justify-between">
                  <span class="strong flex-1">{{ discount.label }}</span>
                  <ui-icon-airbnb
                    [size]="12"
                    [matTooltip]="'Periodically updated on Airbnb.'"
                    class="@md:hidden mr-[2px]"></ui-icon-airbnb>
                </span>
                <span *ngIf="discount.description" class="text-sm text-night">
                  {{ discount.description }}
                </span>
              </span>
              <div class="@md:self-end">
                <div
                  class="flex items-center gap-2 @md:gap-3 mb-2 relative @md:-mr-[1.75rem]"
                  *ngFor="let early of feeDiscountData[discount.key]; let i = index">
                  <ui-icon-airbnb
                    [size]="12"
                    [matTooltip]="'Periodically updated on Airbnb.'"
                    class="hidden @md:block"></ui-icon-airbnb>
                  <mat-form-field
                    class="nopadding flex-1 @md:!w-40 [&_.mat-form-field-flex]:!pr-0 [&_.mat-form-field-suffix]:flex [&_.mat-form-field-suffix]:!top-0 [&_.mat-form-field-suffix]:items-center [&_.mat-form-field-suffix]:self-stretch [&_.mat-form-field-suffix]:mb-1">
                    <input
                      matInput
                      type="number"
                      inputmode="numeric"
                      min="1"
                      max="24"
                      autocomplete="off"
                      placeholder="1"
                      class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                      [(ngModel)]="early.threshold_days"
                      (change)="checkAndSave(discount.key, feeDiscountData[discount.key])" />
                    <span
                      matSuffix
                      class="whitespace-nowrap text-xs @md:text-sm h-full flex items-center rounded-r-md bg-gray-100 px-3 mt-2"
                      >months before</span
                    >
                  </mat-form-field>
                  <mat-form-field
                    class="nopadding !w-[90px] @md:!w-[120px] [&_.mat-form-field-flex]:!pr-0 [&_.mat-form-field-suffix]:flex [&_.mat-form-field-suffix]:!top-0 [&_.mat-form-field-suffix]:items-center [&_.mat-form-field-suffix]:self-stretch [&_.mat-form-field-suffix]:mb-1">
                    <input
                      matInput
                      type="number"
                      inputmode="numeric"
                      min="1"
                      max="100"
                      placeholder="0"
                      class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                      [(ngModel)]="early.value"
                      (change)="checkAndSave(discount.key, feeDiscountData[discount.key])" />
                    <span matSuffix class="h-full flex items-center rounded-r-md text-xs bg-gray-100 px-3 mt-2">%</span>
                  </mat-form-field>
                  <ui-icon
                    icon="griddy-trash-alt"
                    [size]="16"
                    (click)="removeDiscount(discount.key, feeDiscountData[discount.key], i)"
                    class="text-night-lighter hover:text-rose-darker clickable"></ui-icon>
                </div>
                <div class="flex justify-end">
                  <sbnb-button
                    size="mini"
                    [type]="'text-secondary'"
                    (click)="addDiscount(feeDiscountData, discount.key)">
                    <span class="text-sm font-medium">+ Add discount</span>
                  </sbnb-button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'last_minute_discount'">
            <div
              *ngIf="featureFlagAirbnbDiscountsEnabled$ | async"
              class="flex @md:gap-3 gap-1 mb-4 @md:mb-2 @md:flex-row flex-col">
              <span class="flex-1 text-sm flex flex-col gap-1">
                <span class="flex items-center justify-between">
                  <span class="strong flex-1">{{ discount.label }}</span>
                  <ui-icon-airbnb
                    [size]="12"
                    [matTooltip]="'Periodically updated on Airbnb.'"
                    class="@md:hidden mr-[2px]"></ui-icon-airbnb>
                </span>
                <span *ngIf="discount.description" class="text-sm text-night">
                  {{ discount.description }}
                </span>
              </span>

              <div class="@md:self-end">
                <div
                  class="flex items-center gap-2 @md:gap-3 mb-2 relative @md:-mr-[1.75rem]"
                  *ngFor="let lastMinuteDiscount of feeDiscountData[discount.key]; let i = index">
                  <ui-icon-airbnb
                    [size]="12"
                    [matTooltip]="'Periodically updated on Airbnb.'"
                    class="hidden @md:block mr-[2px]"></ui-icon-airbnb>
                  <mat-form-field
                    class="nopadding flex-1 @md:!w-40 [&_.mat-form-field-flex]:!pr-0 [&_.mat-form-field-suffix]:flex [&_.mat-form-field-suffix]:!top-0 [&_.mat-form-field-suffix]:items-center [&_.mat-form-field-suffix]:self-stretch [&_.mat-form-field-suffix]:mb-1">
                    <input
                      matInput
                      type="number"
                      inputmode="numeric"
                      min="1"
                      max="28"
                      autocomplete="off"
                      placeholder="1"
                      class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                      [(ngModel)]="lastMinuteDiscount.threshold_days"
                      (change)="checkAndSave(discount.key, feeDiscountData[discount.key])" />
                    <span
                      matSuffix
                      class="whitespace-nowrap text-xs @md:text-sm h-full flex items-center rounded-r-md bg-gray-100 px-3 mt-2"
                      >days before</span
                    >
                  </mat-form-field>
                  <mat-form-field
                    class="nopadding !w-[90px] @md:!w-[120px] [&_.mat-form-field-flex]:!pr-0 [&_.mat-form-field-suffix]:flex [&_.mat-form-field-suffix]:!top-0 [&_.mat-form-field-suffix]:items-center [&_.mat-form-field-suffix]:self-stretch [&_.mat-form-field-suffix]:mb-1">
                    <input
                      matInput
                      type="number"
                      inputmode="numeric"
                      min="1"
                      max="100"
                      placeholder="0"
                      class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                      [(ngModel)]="lastMinuteDiscount.value"
                      (change)="checkAndSave(discount.key, feeDiscountData[discount.key])" />
                    <span matSuffix class="h-full flex items-center rounded-r-md text-xs bg-gray-100 px-3 mt-2">%</span>
                  </mat-form-field>
                  <ui-icon
                    icon="griddy-trash-alt"
                    [size]="16"
                    (click)="removeDiscount(discount.key, feeDiscountData[discount.key], i)"
                    class="text-night-lighter hover:text-rose-darker clickable"></ui-icon>
                </div>
                <div class="flex justify-end">
                  <sbnb-button
                    size="mini"
                    [type]="'text-secondary'"
                    (click)="addDiscount(feeDiscountData, discount.key)">
                    <span class="text-sm font-medium">+ Add discount</span>
                  </sbnb-button>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <!-- Taxes -->
    <mat-divider *ngIf="enableTaxes && !section" class="!my-6"></mat-divider>
    <div *ngIf="enableTaxes && !section">
      <div class="flex items-center gap-3 mb-4">
        <h3 #section class="flex-1" id="taxes">Taxes</h3>
        <sbnb-button type="secondary" size="mini" [routerLink]="['/settings/taxes/name']">+ Add new</sbnb-button>
      </div>

      <ng-container *ngIf="taxes">
        <sbnb-tax-selection [property]="property" [selectedTaxesUuids]="taxesUuids"></sbnb-tax-selection>
      </ng-container>
    </div>

    <!-- Icon legend -->
    <ng-template #iconLegend>
      <a class="link-grape @md:hidden" (click)="showIconLegend = !showIconLegend">
        {{ showIconLegend ? 'Hide' : 'Show' }} what the logos mean
      </a>
      <div *ngIf="showIconLegend" class="">
        <div class="flex items-center gap-3 mb-2">
          <sbnb-property-update-status [hasAirbnbListing]="true" [hasDirectSites]="false"></sbnb-property-update-status>
          <span class="text-sm">{{ status.Airbnb }}</span>
        </div>

        <div class="flex items-center gap-3 mb-2">
          <sbnb-property-update-status
            [hasAirbnbListing]="true"
            [hasDirectSites]="false"
            [edited]="true"></sbnb-property-update-status>
          <span class="text-sm">{{ status.AirbnbEdited }}</span>
        </div>

        <div class="flex items-center gap-3 mb-2">
          <sbnb-property-update-status
            [hasAirbnbListing]="false"
            [hasDirectSites]="false"
            [hasBookingListing]="true"></sbnb-property-update-status>
          <span class="text-sm">{{ status.Booking }}</span>
        </div>

        <div class="flex items-center gap-3">
          <sbnb-property-update-status [hasAirbnbListing]="false"></sbnb-property-update-status>
          <span class="text-sm flex-1">{{ status.DirectSites }}</span>
        </div>
      </div>
    </ng-template>

    <!-- Mobile legend for update icons -->
  </div>
</ng-container>
